import { useSession } from 'next-auth/react';
import { Prisma } from '@prisma/client';
import { fetchWithToken } from '../../helpers/fetchWithToken';
import { useQuery } from '@tanstack/react-query';

const teamWithCampaigns = Prisma.validator<Prisma.TeamArgs>()({
  include: { campaigns: true },
});

export type TeamWithCampaigns = Prisma.TeamGetPayload<typeof teamWithCampaigns>;

export type TeamsWithCampaigns = Prisma.TeamGetPayload<
  typeof teamWithCampaigns
>[];

export function useTeam(slug: string): {
  team: TeamWithCampaigns | null;
  isLoading: boolean;
  isError: boolean;
} {
  const { data: session } = useSession();

  const query = useQuery<TeamWithCampaigns>(
    [slug],
    () => fetchWithToken(`/teams?slug=${slug}`, session?.accessToken as string),
    {
      enabled: !!session?.accessToken,
      retry: false,
    },
  );

  return {
    team: query.data,
    isLoading: query.isLoading || !session?.accessToken,
    isError: query.isError,
  };
}

export function useTeams(): {
  teams: TeamsWithCampaigns | null;
  isLoading: boolean;
  isError: boolean;
} {
  const { data: session } = useSession();

  const query = useQuery<TeamsWithCampaigns>(
    [],
    () => fetchWithToken('teams', session?.accessToken as string),
    {
      enabled: !!session?.accessToken,
      retry: false,
    },
  );

  return {
    teams: query.data,
    isLoading: query.isLoading || !session?.accessToken,
    isError: query.isError,
  };
}
